export const  env =  (window.location.host.indexOf("localhost") > -1) ? 'dev' : 'prod'

console.log('Running in ' + env + ' environment.');